import Alertify from 'alertifyjs';

export default {
    init: (title, ok, cancel) => {
        const alertSettings = {
            'closable': false,
            'transition': 'fade',
            'movable': false,
            'defaultFocusOff': true,
            'glossary': {
                title: title,
                ok: ok,
                cancel: cancel
            }
        };
        Object.assign(Alertify.defaults, alertSettings);
    },
    alert: (message, onOK) => {
        Alertify.alert(message, onOK);
    },
    confirm: (message, onOK) => {
        Alertify.confirm(message, onOK);
    }
}
